import { Injectable } from "@angular/core";
import {  ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "../common-services/user.services";
import { AuthenticationService } from "../data-services/authentication.service";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuard {

    constructor(
        private router: Router,
        private userService: UserService,
        private authenticationService: AuthenticationService,
    ) { }

    /**
     * Check if the user is logged in before calling http
     *
     * @param route
     * @param state
     * @returns {boolean}
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (this.userService.isLoggedIn()) {
            return true;
        }
        this.router.navigate(['/authentication/login']).then(() => {
          window.location.reload();
        });
        return false;
    }
 
}
